import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import PropTypes from 'prop-types';
import exclamationIcon from './red-exclamation.svg';

export const text = {
  quotaWarningAlt: 'Exclamation Icon',
};

export const QuotaWarning = ({ quotaWarning }) => (
  <div className={styles.quotaWarningContainer}>
    <img
      className={styles.quotaWarningIcon}
      src={exclamationIcon}
      alt={text.quotaWarningAlt}
    />
    <div className={styles.quotaWarning}>{quotaWarning}</div>
  </div>
);

QuotaWarning.propTypes = {
  quotaWarning: PropTypes.string,
};

export default enhance(QuotaWarning);
